//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
//#endregion

/**
 * 일반/특수 건강진단 - 일반건강진단 (HEA_BASIC_01) 전용 로직
 * other 케이스에서 사용
 */

// 일반건강진단 인쇄 함수 (PrintLogic1) - printItem printType: '1'
export const PrintLogic1 = async (
  documentData,
  dispatch,
  setLoading,
  rowData1,
  searchRef,
  userInfo
) => {
  setLoading(true);

  try {
    // 데이터 확인
    const currentRowData = (rowData1 || []).filter((row) => !row.deleteYn);

    if (currentRowData.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return null;
    }

    // 사업장명 가져오기
    const custNm =
      searchRef?.current?.custList?.find(
        (item) => item.value === searchRef?.current?.custCd
      )?.custNm || '';

    // HeaderData 설정
    const headerData = {
      custNm: custNm, // 사업장명
      createDate: dayjs().format('YYYY-MM-DD'), // 작성일자
      userNm: userInfo.userNm || '', // 사용자명
    };

    // TableData 매핑 (레포트 양식에 맞게) - 최신 rowData1 사용
    const tableData = currentRowData.map((row, index) => {
      // 검진일 포맷팅
      const checkupDate = row.hcDate
        ? dayjs(row.hcDate).format('YYYY-MM-DD')
        : '';

      // 유효일자 포맷팅
      const effeDate = row.hcEffeDate
        ? dayjs(row.hcEffeDate).format('YYYY-MM-DD')
        : '';

      return {
        no: index + 1,
        depNm1: row.depNm1 || '', // 본부
        depNm2: row.depNm2 || '', // 부서
        depNm3: row.depNm3 || '', // 팀
        depNm4: row.depNm4 || '', // 파트
        position: row.position || '', // 직책
        name: row.name || '', // 성명
        hcCycle: row.hcCycle || '', // 검진주기(년)
        hcDate: checkupDate, // 검진일
        hcEffeDate: effeDate, // 유효일자
        hcCheckupCenter: row.hcCheckupCenter || '', // 검진기관
        hcAlarmYn: row.hcAlarmYn || '', // 알람여부(Y/N)
        hcRemark: row.hcRemark || '', // 비고
      };
    });

    const printData = {
      FileName: 'HEA_BASIC_01',
      HeaderData: JSON.stringify(headerData),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};

// 건강진단 실시 지침서 인쇄 함수 (PrintLogic2) - printItem printType: '2'
export const PrintLogic2 = async (
  _value1,
  dispatch,
  setLoading,
  searchRef
) => {
  setLoading(true);

  try {
    const printData = {
      FileName: 'HEA_BASIC',
      HeaderData: JSON.stringify({}),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};

